(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.resi-v2.web 
  (:require
   [common.util :as cu]
   [frontend.ui.component.image-cropper.view :as image-cropper]
   [frontend.ui.component.lp-portal.report.component.block-table.view :as block-table]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.view :as horizontal-table]
   [frontend.ui.component.lp-portal.report.component.vertical-table.view :as vertical-table]
   [frontend.ui.component.lp-portal.voima-components.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.chart-card.chart-card :as chart-card]
   [frontend.ui.component.lp-portal.voima-components.free-text-card.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.voima-components.section.view :as section]
   [frontend.ui.component.lp-portal.voima-components.text-content.view :as text-content]
   [frontend.ui.component.table.view :as table]))

(defn image-view
  [{:keys [title height width image-key image-ui-data footnote? contact-image?]}
   {:keys [save-image-with-text _save-text edit-mode?] :as props}]
  (let [id (str "img-" (name image-key))
        input-id (str "file-" (name image-key))
        rich-image-path (get-in image-ui-data [:rich-image-path])
        image-src (get-in image-ui-data [:image])]
    [:div
     [card/card
      {:title title}
      (cond
        (and (cu/blank-value? image-src) edit-mode?)
        [:div
         {:style {:max-width (if contact-image? "180px" "100%")}} 
         [image-cropper/modal-image-cropper
          {:input-id      input-id
           :target-width  width
           :target-height height
           :round?        false
           :on-cropped    #(save-image-with-text rich-image-path %)
           :size          :xs}]]
        (and (cu/blank-value? image-src) (not edit-mode?) contact-image?)
        [:div
         {:style {:width       (str 180 "px")
                  :height      (str 180 "px")
                  :background  "white"
                  :display     "flex"
                  :align-items "center"
                  :justify-content "center"
                  :box-sizing  "border-box"}}] 
        :else
        [:div
         [:img {:id    id
                :src   image-src
                :style {:max-width "100%"}}]
         (when edit-mode?
           [:i.fal.fa-trash-alt
            {:on-click #(save-image-with-text rich-image-path "")
             :style    {:margin-left "6px"
                        :cursor      "pointer"}}])])
      (when footnote?
        (text-content/optional-footnote image-ui-data 
                                        (assoc props :image-with-footnote? true)))]]))

(defn strategy
  [{:keys [strategy]} props]
  [:div
   [free-text-card/view
    "Strategy"
    strategy
    props]])

(defn portfolio-update-text
  [{:keys [portfolio-update-text]} props]
  [:div
   [free-text-card/view
    "Portfolio update"
    portfolio-update-text
    props]])

(defn investment-activity-and-pipeline-text
  [{:keys [investment-activity-and-pipeline-text]} props]
  [:div
   [free-text-card/view
    "Investment activity and pipeline"
    investment-activity-and-pipeline-text
    props]])

(defn performance-and-outlook-text
  [{:keys [performance-and-outlook-text]} props]
  [:div
   [free-text-card/view
    "Forward Funding Investments and Major Capex Projects"
    performance-and-outlook-text
    props]])

;; ---- ESG texts ----

(defn esg-summary-text
  [{:keys [esg-summary-text]} props]
  [:div
   [free-text-card/view
    "Sustainability Summary"
    esg-summary-text
    props]])

(defn gresb-text
  [{:keys [gresb-text]} props]
  [:div
   [free-text-card/view
    "GRESB"
    gresb-text
    props]])

(defn epc-text
  [{:keys [epc-text]} props]
  [:div
   [free-text-card/view
    "Energy Performance Certificates"
    epc-text
    props]])

(defn eu-taxonomy-text
  [{:keys [eu-taxonomy-text]} props]
  [:div
   [free-text-card/view
    "EU Taxonomy Alignment"
    eu-taxonomy-text
    props]])

(defn green-certificates-text
  [{:keys [green-certificates-text]} props]
  [:div
   [free-text-card/view
    "Green Building Certications"
    green-certificates-text
    props]])

(defn green-electricity-text
  [{:keys [green-electricity-text]} props]
  [:div
   [free-text-card/view
    "Renewable energy"
    green-electricity-text
    props]])

(defn esg-investments-text
  [{:keys [esg-investments-text]} props]
  [:div
   [free-text-card/view
    "Sustainability investments"
    esg-investments-text
    props]])

(defn crrem-pathway-text
  [{:keys [crrem-pathway-text]} props]
  [:div
   [free-text-card/view
    "2035 Net Zero Target"
    crrem-pathway-text
    props]])

(defn tenant-satisfaction-text
  [{:keys [tenant-satisfaction-text]} props]
  [:div
   [free-text-card/view
    "Tenant satisfaction"
    tenant-satisfaction-text
    props]])

(defn fees-disclosure-text
  [{:keys [fees-disclosure-text]} props]
  [:div
   [free-text-card/view
    "Disclosure About Service Fees Charged by CapMan"
    fees-disclosure-text
    props]])

(defn disclaimer-text
  [{:keys [disclaimer-text]} props]
  [:div
   [free-text-card/view
    "Disclaimer"
    disclaimer-text
    props]])

(defn fund-summary
  [{:keys [fund-summary]} props]
  [:div
   [vertical-table/table
    "Fund summary"
    fund-summary
    props]])

(defn contact-information
  [{:keys [contact-information contact-images]} props]
  [card/card {:title "Contact information"}
   [:div
    [:div
     {:style {:overflow-x     "auto"
              :max-width      "100%"
              :margin-left    "30px"
              :padding-bottom "10px"
              :margin-bottom  "20px"}}
     [:div
      {:style {:display               "grid"
               :grid-template-columns "repeat(5, 1fr)"
               :gap                   "10px"
               :margin-top            "20px"
               :min-width             "1000px"
               :justify-content       "start"}}
      (for [[contact-key image-ui-data] contact-images]
        ^{:key (str "img-" contact-key)}
        [image-view
         {:width           220
          :height          220
          :image-ui-data   image-ui-data
          :image-key       contact-key
          :contact-image?  true}
         props])]]
    [horizontal-table/table
     nil
     contact-information
     (assoc props :hide-footnote? true)]]])


(defn valuation-details
  [{:keys [valuation-details]} props]
  [:div
   [vertical-table/table
    "Legal, Administration and Property Valuation Details"
    valuation-details
    props]])

(defn fund-capital-metrics
  [{:keys [fund-capital-metrics]} props]
  [:div
   [vertical-table/table 
    "Fund capital"
    fund-capital-metrics
    (assoc props :hide-footnote? true)]])

(defn fund-kpis-metrics
  [{:keys [fund-kpis-metrics]} props]
  [:div
   [vertical-table/table
    "Fund KPIs"
    fund-kpis-metrics
    (assoc props :hide-footnote? true)]])

(defn performance-metrics
  [{:keys [performance-metrics]} props]
  [:div
   [vertical-table/table
    "Performance metrics"
    performance-metrics 
    (assoc props :hide-footnote? true)]])

(defn portfolio-metrics
  [{:keys [portfolio-metrics]} props]
  [:div
   [vertical-table/table
    "Portfolio metrics"
    portfolio-metrics 
    props]])

(defn market-overview
  [{:keys [market-overview]} props]
  [:div
   [table/editable-table market-overview props
    [vertical-table/table
    "Residential Market Snapshot"
    market-overview
    props]]])

(defn fund-returns-table
  [{:keys [fund-returns-table]} props]
  [:div
   [vertical-table/table
    "Fund Returns in %"
    fund-returns-table
    props]])

(defn benchmark-index
  [{:keys [benchmark-index]} props]
  [:div
   [vertical-table/table
    "Benchmark Index: INREV European ODCE Index, Total Return in %"
    benchmark-index
    props]])

;; -------- Charts --------

(defn nav-per-unit
  [{:keys [nav-per-unit]} props]
  [:div
   [chart-card/view
    "NAV per unit"
    nav-per-unit
    props]])

(defn nav-bridge
  [{:keys [nav-bridge]} props]
  [:div
   [chart-card/view
    "NAV bridge"
    nav-bridge
    props]])

(defn loan-to-gav
  [{:keys [loan-to-gav]} props]
  [:div
   [chart-card/view
    "Loan-to-GAV"
    loan-to-gav
    props]])

(defn empty-chart-data?
  [chart-data]
  (->> chart-data
       :figures
       :series
       (filter (fn [{:keys [data]}]
                 (seq (remove nil? data))))
       (count)
       (= 0)))

(defn portfolio-noi-and-niy
  [{:keys [portfolio-noi-and-niy]} props]
  [:div
   [chart-card/view
    "Portfolio NOI and NIY"
    portfolio-noi-and-niy
    (assoc props :hide-footnote? true)]])

(defn like-for-like-rental-growth
  [{:keys [like-for-like-rental-growth]} props]
  (when-not (empty-chart-data? like-for-like-rental-growth)
    [:div
     [chart-card/view
      "Rental Growth Y-o-Y"
      like-for-like-rental-growth
      (assoc props :hide-footnote? true)]]))

(defn valuation-change
  [{:keys [valuation-change]} props]
  [:div
   [chart-card/view
    "Valuation Change Q-o-Q"
    valuation-change
    props]])

;; -------- Debt & Portfolio --------

(defn debt-kpis
  [{:keys [debt-kpis]} props]
  [:div
   [vertical-table/table
    "Debt KPIs"
    debt-kpis
    props]])

(defn debt-facilities
  [{:keys [debt-facilities]} props]
  [:div
   [horizontal-table/table
    "Debt facilities"
    debt-facilities
    props]])

(defn portfolio-summary
  [{:keys [portfolio-summary]} props]
  [:div
   [vertical-table/table
    "Portfolio summary"
    portfolio-summary
    props]])

(defn acquisitions
  [{:keys [acquisitions]} props]
  [:div
   [horizontal-table/table
    "Acquisitions TTM"
    acquisitions
    props]])

(defn dispositions
  [{:keys [dispositions]} props]
  [:div
   [horizontal-table/table
    "Dispositions TTM"
    dispositions
    props]])

;; -------- ESG --------

(defn gresb-by-year
  [{:keys [gresb-by-year]} props]
  [:div
   [table/editable-table gresb-by-year props
    [horizontal-table/table
     "Fund GRESB rating by year"
     gresb-by-year
     (assoc props :hide-footnote? true)]]])

(defn portfolio-epc
  [{:keys [portfolio-epc]} props]
  [:div
   [table/editable-table portfolio-epc props
    [horizontal-table/table
     "Portfolio EPC"
     portfolio-epc
     props]]])

(defn green-certs-by-country
  [{:keys [green-certs-by-country]} props]
  [:div
   [table/editable-table green-certs-by-country props
    [horizontal-table/table
     "Certifications by Country"
     green-certs-by-country
     props]]])

(defn share-of-fossil-free-energy
  [{:keys [share-of-fossil-free-energy]} props]
  [:div
   [table/editable-table share-of-fossil-free-energy props
    [horizontal-table/table
     "Share Of Renewable Energy"
     share-of-fossil-free-energy
     (assoc props :hide-footnote? true)]]])

(defn esg-nps
  [{:keys [esg-nps]} props]
  [:div
   [table/editable-table esg-nps props
    [horizontal-table/table
     "Overall Satisfaction & NPS"
     esg-nps
     (assoc props :hide-footnote? true)]]])

(defn emissions
  [{:keys [emissions]} props]
  [:div
   [table/editable-table emissions props
    [horizontal-table/table
     "Greenhouse Gas Emissions"
     emissions
     (assoc props :hide-footnote? true)]]])

#_(defn annual-carbon-intensity
  [{:keys [annual-carbon-intensity]} props]
  [:div
   [chart-card/view
    "Annual carbon intensity"
    annual-carbon-intensity
    props]])

(defn cmrf-towards-net-zero
  [{:keys [cmrf-towards-net-zero]} props]
  [:div
   [chart-card/view
    "CMRF Operational Net Zero by 2035 Pathway (SBTi)"
    cmrf-towards-net-zero
    (assoc props :hide-footnote? true)]])

;; -------- Financials --------

(defn nav-breakdown-ifrs
  [{:keys [nav-breakdown-ifrs]} props]
  [:div
   [vertical-table/table
    "NAV breakdown (IFRS)"
    nav-breakdown-ifrs
    props]])

(defn nav-breakdown-inrev
  [{:keys [nav-breakdown-inrev]} props]
  [:div
   [vertical-table/table
    "NAV breakdown (INREV)"
    nav-breakdown-inrev
    props]])

(defn income-statement
  [{:keys [income-statement]} props]
  [:div
   [vertical-table/table
    "Consolidated Statement of Comprehensive Income (INREV), €"
    income-statement
    props]])

(defn financial-positions-statement-1
  [{:keys [financial-positions-statement-1]} props]
  [:div
   [vertical-table/table
    "Consolidated Statement of Financial Positions (INREV), €"
    financial-positions-statement-1
    props]])

(defn financial-positions-statement-2
  [{:keys [financial-positions-statement-2]} props]
  [:div
   [vertical-table/table
    "Consolidated Statement of Financial Positions (INREV), €"
    financial-positions-statement-2
    props]])

(defn cash-flows-statement-1
  [{:keys [cash-flows-statement-1]} props]
  [:div
   [vertical-table/table
    "Consolidated Statement of Cash Flows (INREV), €"
    cash-flows-statement-1
    props]])

(defn cash-flows-statement-2
  [{:keys [cash-flows-statement-2]} props]
  [:div
   [vertical-table/table
    "Consolidated Statement of Cash Flows (INREV), €"
    cash-flows-statement-2
    props]])

;; -------- Country Portfolios --------

(defn portfolio-denmark
  [{:keys [portfolio-denmark]} props]
  [:div
   [horizontal-table/table
    "Portfolio (Denmark)"
    portfolio-denmark
    props]])

(defn portfolio-finland
  [{:keys [portfolio-finland]} props]
  [:div
   [horizontal-table/table
    "Portfolio (Finland)"
    portfolio-finland
    props]])

(defn portfolio-sweden
  [{:keys [portfolio-sweden]} props]
  [:div
   [horizontal-table/table
    "Portfolio (Sweden)"
    portfolio-sweden
    props]])

;; -------- Misc --------

(defn glossary
  [{:keys [glossary]} props]
  [:div
   [block-table/table
    "Glossary"
    glossary
    props]])

(def box-style
  {:background "#F0EEEA"
   :border "1px solid #DDD"
   :borderRadius "4px"
   :padding "10px 12px"
   :display "flex"
   :alignItems "center"
   :minHeight "64px"})

(def value-style
  {:fontWeight 700
   :fontSize "19px"
   :lineHeight 1.1
   :marginBottom "4px"})

(def label-style
  {:fontSize "15px"
   :color "#555"})

(def grid-2col
  {:display "grid"
   :gridTemplateColumns "repeat(2, 1fr)"
   :gap "20px"})

(defn- value-from-row
  [row]
  (some-> row :row-data first))

(defn- label-from-row
  [row]
  (some-> row :row-key))

(defn snapshot-element-web
  [entries]
  (let [single-entry? (= 1 (count entries))]
    ^{:key (str "snapshot-" (:default-label (first entries)))}
    [:div {:style box-style}
     (if single-entry?
       (let [{:keys [row-data default-label]} (first entries)
             value (value-from-row row-data)
             label (or (label-from-row row-data) default-label)]
         [:div
          [:div {:style value-style} (str value)]
          [:div {:style label-style} (str label)]])
       [:div {:style {:display "grid"
                      :gridTemplateColumns "100px 1fr"
                      :columnGap "8px"
                      :rowGap "6px"
                      :width "100%"}}
        (for [{:keys [row-data default-label]} entries]
          ^{:key (str (label-from-row row-data) "-" (:row-data row-data))}
          [:<>
           [:div {:style value-style} (str (value-from-row row-data))]
           [:div {:style label-style} (str (or (label-from-row row-data) default-label))]])])]))

(defn portfolio-snapshot-web
  [snapshot-data props]
  (let [rows      (-> snapshot-data :figures :data)
        elements  [(snapshot-element-web [{:row-data (nth rows 0) :default-label "properties"}])
                   (snapshot-element-web [{:row-data (nth rows 1) :default-label "physical occupancy"}])
                   (snapshot-element-web [{:row-data (nth rows 2) :default-label "average apartment size"}])
                   (snapshot-element-web [{:row-data (nth rows 3) :default-label "NIY"}
                                          {:row-data (nth rows 4) :default-label "EY"}])
                   (snapshot-element-web [{:row-data (nth rows 5) :default-label "apartments"}])
                   (snapshot-element-web [{:row-data (nth rows 6) :default-label "of GAV in capitals"}])
                   (snapshot-element-web [{:row-data (nth rows 7) :default-label "average rent"}])
                   (snapshot-element-web [{:row-data (nth rows 8) :default-label "of portfolio income-generating"}])]]
    [table/editable-table snapshot-data props
     [card/card {:title "Portfolio Snapshot"}
     [:div {:style grid-2col}
      (for [[i el] (map-indexed vector elements)]
        ^{:key (str "ps-" i)} el)]]]))

(defn financial-snapshot-web
  [snapshot-data props]
  (let [rows      (-> snapshot-data :figures :data)
        elements  [(snapshot-element-web [{:row-data (nth rows 0) :default-label "GAV"}
                                          {:row-data (nth rows 1) :default-label "NAV"}])
                   (snapshot-element-web [{:row-data (nth rows 2) :default-label "LTGAV"}
                                          {:row-data (nth rows 3) :default-label "LTV"}])
                   (snapshot-element-web [{:row-data (nth rows 4) :default-label "total return (TTM)"}])
                   (snapshot-element-web [{:row-data (nth rows 5) :default-label "distribution yield on NAV (TTM)"}])]]
    [table/editable-table snapshot-data props
     [card/card {:title "Financial Snapshot"}
     [:div {:style grid-2col}
      (for [[i el] (map-indexed vector elements)]
        ^{:key (str "fs-" i)} el)]]]))

(defn esg-snapshot-web
  [snapshot-data props]
  (let [rows      (-> snapshot-data :figures :data)
        elements  [(snapshot-element-web [{:row-data (nth rows 0) :default-label "EPC A-C by GAV"}])
                   (snapshot-element-web [{:row-data (nth rows 1) :default-label "of assets certified"}])
                   (snapshot-element-web [{:row-data (nth rows 2) :default-label "CO2 emissions CO2e/m²"}])
                   (snapshot-element-web [{:row-data (nth rows 3) :default-label "GRESB rating"}])]]
    [table/editable-table snapshot-data props
     [card/card {:title "ESG Snapshot"}
      [:div {:style grid-2col}
       (for [[i el] (map-indexed vector elements)]
         ^{:key (str "esg-" i)} el)]]]))


;; -------- View  --------


(defn fund-summary-section
  [report-id fund-ui-data props]
  [:div {:id (str "fund-summary-" report-id)}
   [section/section
    "Fund summary"
    (str "fund-summary-section-" report-id)
    [:div
     {:style {:display "flex"
              :flex-direction "column"
              :gap "12px"}}
     [fund-summary fund-ui-data props]
     [strategy fund-ui-data props]
     [contact-information fund-ui-data props]
     [valuation-details fund-ui-data props]]]])

(defn quarter-update-section
  [report-id fund-ui-data props]
  [:div {:id (str "quarter-update-" report-id)}
   [section/section
    "Commentary"
    (str "quarter-update-section-" report-id)
    [:div
     {:style {:display "flex"
              :flex-direction "column"
              :gap "12px"}}
     [portfolio-update-text fund-ui-data props]
     [performance-and-outlook-text fund-ui-data props]
     [investment-activity-and-pipeline-text fund-ui-data props]
     [image-view
      {:title "Commentary image (left)"
       :width 1000
       :height 600
       :image-ui-data (:quarter-update-image-1 fund-ui-data)
       :image-key :quarter-update-image-1
       :footnote? true}
      props]
     [image-view
      {:title "Commentary image (right)"
       :width 1000
       :height 600
       :image-ui-data (:quarter-update-image-2 fund-ui-data)
       :image-key :quarter-update-image-2
       :footnote? true}
      props]]]])

(defn key-metrics-section
  [report-id fund-ui-data props]
  [:div {:id (str "key-metrics-" report-id)}
   [section/section
    "Key metrics"
    (str "key-metrics-section-" report-id)
    [:div
     {:style {:display "flex"
              :flex-direction "column"
              :gap "12px"}}
     [fund-capital-metrics fund-ui-data props]
     [fund-kpis-metrics fund-ui-data props]
     [performance-metrics fund-ui-data props]
     [portfolio-metrics fund-ui-data props]
     [portfolio-snapshot-web (:portfolio-snapshot fund-ui-data) props]
     [financial-snapshot-web (:financial-snapshot fund-ui-data) props]
     [esg-snapshot-web (:esg-snapshot fund-ui-data) props]]]])

(defn market-overview-section
  [report-id fund-ui-data props]
  [:div {:id (str "market-overview-" report-id)}
   [section/section
    "Market overview"
    (str "market-overview-section-" report-id)
    [:div
     {:style {:display "flex"
              :flex-direction "column"
              :gap "12px"}}
     [market-overview fund-ui-data props]
     [image-view
      {:title "Market overview image"
       :width 1500
       :height 700
       :image-ui-data (:market-overview-image fund-ui-data)
       :image-key :market-overview-image
       :footnote? true}
      props]]]])

(defn fund-returns-section
  [report-id fund-ui-data props]
  [:div {:id (str "fund-returns-" report-id)}
   [section/section
    "Fund returns"
    (str "fund-returns-section-" report-id)
    [:div
     {:style {:display "flex"
              :flex-direction "column"
              :gap "12px"}}
     [fund-returns-table fund-ui-data props]
     [benchmark-index fund-ui-data props]
     [nav-per-unit fund-ui-data props]
     [nav-bridge fund-ui-data props]]]])

(defn debt-financing-section
  [report-id fund-ui-data props]
  [:div {:id (str "debt-financing-" report-id)}
   [section/section
    "Debt financing"
    (str "debt-financing-section-" report-id)
    [:div
     {:style {:display "flex"
              :flex-direction "column"
              :gap "12px"}}
     [debt-kpis fund-ui-data props]
     [debt-facilities fund-ui-data props]
     [loan-to-gav fund-ui-data props]]]])

(defn portfolio-section
  [report-id fund-ui-data props]
  [:div {:id (str "portfolio-" report-id)}
   [section/section
    "Portfolio overview"
    (str "portfolio-section-" report-id)
    [:<>
     [portfolio-summary fund-ui-data props]
     [chart-card/view
      "Fair value by country"
      (:fair-value-by-country fund-ui-data)
      (assoc props :hide-footnote? true)]
     [chart-card/view
      "Fair value by location"
      (:fair-value-by-location fund-ui-data)
      (assoc props :hide-footnote? true)]
     [chart-card/view
      "Fair value by type"
      (:fair-value-by-type fund-ui-data)
      (assoc props :hide-footnote? true)]
     [portfolio-noi-and-niy fund-ui-data props]
     [like-for-like-rental-growth fund-ui-data props]
     [valuation-change fund-ui-data props]]]])

(defn investment-activity-section
  [report-id fund-ui-data props]
  [:div {:id (str "investment-activity-" report-id)}
   [section/section
    "Investment activity"
    (str "investment-activity-section-" report-id)
    [:div
     {:style {:display "flex"
              :flex-direction "column"
              :gap "12px"}}
     [acquisitions fund-ui-data props]
     [dispositions fund-ui-data props]
     [image-view
      {:title "Investment activity image (left)"
       :width 500
       :height 300
       :image-ui-data (:investment-activity-image-1 fund-ui-data)
       :image-key :investment-activity-image-1
       :footnote? true}
      props]
     [image-view
      {:title "Investment activity image (right)"
       :width 500
       :height 300
       :image-ui-data (:investment-activity-image-2 fund-ui-data)
       :image-key :investment-activity-image-2
       :footnote? true}
      props]]]])

(defn sustainability-section
  [report-id fund-ui-data props]
  [:div {:id (str "sustainability-" report-id)}
   [section/section
    "Sustainability"
    (str "sustainability-section-" report-id)
    [:div
     {:style {:display "flex"
              :flex-direction "column"
              :gap "12px"}}
     [esg-summary-text fund-ui-data props]
     [gresb-text fund-ui-data props]
     [gresb-by-year fund-ui-data props]
     [image-view
      {:title "Gresb logo image"
       :width 200
       :height 350
       :image-ui-data (:gresb-logo-image fund-ui-data)
       :image-key :gresb-logo-image
       :footnote? false}
      props]
     [epc-text fund-ui-data props]
     [portfolio-epc fund-ui-data props]
     [eu-taxonomy-text fund-ui-data props]
     [green-certificates-text fund-ui-data props]
     [green-certs-by-country fund-ui-data props]
     [image-view
      {:title "Certificate image (left)"
       :width 200
       :height 200
       :image-key :green-certificate-image-1
       :image-ui-data (:green-certificate-image-1 fund-ui-data)}
      props]
     [image-view
      {:title "Certificate image (right)"
       :width 300
       :height 130
       :image-key :green-certificate-image-2
       :image-ui-data (:green-certificate-image-2 fund-ui-data)}
      props]
     [green-electricity-text fund-ui-data props]
     [share-of-fossil-free-energy fund-ui-data props]
     [esg-investments-text fund-ui-data props]
     [image-view
      {:title "Sustainability investments image"
       :width 500
       :height 300
       :image-ui-data (:esg-investments-image fund-ui-data)
       :image-key :esg-investments-image
       :footnote? true}
      props]
     [crrem-pathway-text fund-ui-data props]
     [emissions fund-ui-data props]
     [image-view
      {:title "CRREM logo image"
       :width 200
       :height 200
       :image-key :crrem-logo-image
       :image-ui-data (:crrem-logo-image fund-ui-data)}
      props]
     [cmrf-towards-net-zero fund-ui-data props]
     [tenant-satisfaction-text fund-ui-data props]
     [esg-nps fund-ui-data props]]]])

(defn financial-statements-section
  [report-id fund-ui-data props]
  [:div {:id (str "financial-statements-" report-id)}
   [section/section
    "Financial statements"
    (str "financial-statements-section-" report-id)
    [:div
     {:style {:display "flex"
              :flex-direction "column"
              :gap "12px"}}
     [nav-breakdown-ifrs fund-ui-data props]
     [nav-breakdown-inrev fund-ui-data props]
     [income-statement fund-ui-data props]
     [fees-disclosure-text fund-ui-data props]
     [financial-positions-statement-1 fund-ui-data props]
     [financial-positions-statement-2 fund-ui-data props]
     [cash-flows-statement-1 fund-ui-data props]
     [cash-flows-statement-2 fund-ui-data props]]]])

(defn property-portfolio-section
  [report-id fund-ui-data props]
  [:div {:id (str "property-portfolio-" report-id)}
   [section/section
    "Property portfolio"
    (str "property-portfolio-section-" report-id)
    [:div
     {:style {:display "flex"
              :flex-direction "column"
              :gap "12px"}}
     [portfolio-denmark fund-ui-data props]
     [portfolio-finland fund-ui-data props]
     [portfolio-sweden fund-ui-data props]]]])

(defn glossary-section
  [report-id fund-ui-data props]
  [:div {:id (str "glossary-" report-id)}
   [section/section
    "Glossary"
    (str "Glossary-section-" report-id)
    [:div
     {:style {:display "flex"
              :flex-direction "column"
              :gap "12px"}}
     [glossary fund-ui-data props]
     [disclaimer-text fund-ui-data props]]]])

(defn view
  [{:keys [fund-ui-data report] :as props}]
  (let [report-id (some->> report :db/id)]
    [:div
     [image-view
      {:title "PDF cover image"
       :width 1200
       :height 1698
       :image-ui-data (:pdf-cover-image fund-ui-data)
       :image-key :pdf-cover-image}
      props]
     [image-view
      {:title "Table of contents image"
       :width 595
       :height 842
       :image-ui-data (:pdf-toc-image fund-ui-data)
       :image-key :pdf-toc-image}
      props]
     (fund-summary-section report-id fund-ui-data props)
     (key-metrics-section report-id fund-ui-data props)
     (quarter-update-section report-id fund-ui-data props)
     (market-overview-section report-id fund-ui-data props)
     (fund-returns-section report-id fund-ui-data props)
     (debt-financing-section report-id fund-ui-data props)
     (portfolio-section report-id fund-ui-data props)
     (investment-activity-section report-id fund-ui-data props)
     (sustainability-section report-id fund-ui-data props)
     (financial-statements-section report-id fund-ui-data props)
     (property-portfolio-section report-id fund-ui-data props)
     (glossary-section report-id fund-ui-data props)]))
